import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconHomeProps } from './IconHome.types'
import * as Styled from './styles/IconHome.style'

import { nonThemeableRules } from '../../ruleSet'

const IconHome: FC<IconHomeProps> = ({
  size = nonThemeableRules.defaultSize as number as IconHomeProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconHomeProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M132 171.9v-43.8c-.1-6.8-5.7-12.2-12.5-12.1h-15.1c-6.8-.1-12.3 5.3-12.5 12.1v43.8M84.2 25S29.1 65.8 23.4 71.2c-8.9 8.3 1.3 20.9 12.1 20.9h121.6c10.7 0 19.7-13.3 12.1-20.9S108.3 25 108.3 25c-9.1-7.3-17-5.6-24.1 0z'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M155.9 60.3V20.5h-19.7c-7.1 0-12.9 5.8-12.9 12.9V36M35.7 91.9h120v64c0 8.8-7.2 16-16 16h-88c-8.8 0-16-7.2-16-16v-64zm77.1 52.5h5.9'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconHome
